import { render, staticRenderFns } from "./InputError.vue?vue&type=template&id=71e2caba&"
import script from "./InputError.vue?vue&type=script&lang=js&"
export * from "./InputError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports